<template>
  <div class="contact_us_2">
    <div class="responsive-container-block big-container">
      <div class="blueBG">
      </div>
      <div class="responsive-container-block container">
        <form ref="form" v-if="!formHasBeenSent" @submit.prevent="handleData" class="form-box">
          <div class="container-block form-wrapper">
            <p class="text-blk contactus-head">
              Contacteer ons
            </p>
            <p class="text-blk contactus-subhead">
              Wij helpen u graag verder!
            </p>
            <div class="responsive-container-block">
              <div class="responsive-cell-block wk-ipadp-6 wk-tab-12 wk-mobile-12 wk-desk-6" id="i10mt">
                <p class="text-blk input-title">
                  VOORNAAM
                </p>
                <input v-model="formData.from_firstname" class="input" id="ijowk" name="from_firstname"
                  placeholder="Vul uw voornaam in...">
                <p v-if="userTriedToSend && !formFieldsValidity.from_firstname" class="error">Vul dit veldje in</p>
              </div>
              <div class="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                <p class="text-blk input-title">
                  ACHTERNAAM
                </p>
                <input v-model="formData.from_lastname" class="input" id="indfi" name="from_lastname"
                  placeholder="Vul uw achternaam in...">
                <p v-if="userTriedToSend && !formFieldsValidity.from_lastname" class="error">Vul dit veldje in</p>

              </div>
              <div class="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                <p class="text-blk input-title">
                  EMAIL
                </p>
                <input v-model="formData.from_email" class="input" id="ipmgh" name="from_email"
                  placeholder="Vul uw email adres in...">
                <p v-if="userTriedToSend && !formFieldsValidity.from_email" class="error">Vul een geldig email adres in
                </p>

              </div>
              <div class="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                <p class="text-blk input-title">
                  TELEFOONNUMMER
                </p>
                <input v-model="formData.from_phonenumber" class="input" id="imgis" name="from_phonenumber"
                  placeholder="Typ uw telefoonnumer in...">
                <p v-if="userTriedToSend && !formFieldsValidity.from_phonenumber" class="error">Vul een geldige
                  telefoonnummer
                  in</p>

              </div>
              <div class="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-12 wk-ipadp-12" id="i634i">
                <p class="text-blk input-title">
                  WAT WILT U ONS VRAGEN
                </p>
                <textarea v-model="formData.message" class="textinput" id="i5vyy" name="message"
                  placeholder="Vul alstublieft iets in..."></textarea>
                <p v-if="userTriedToSend && !formFieldsValidity.message" class="error">Vul dit veldje in</p>

              </div>
            </div>
            <button type="submit" class="submit-btn" :disabled="formIsLoading" :class="{ 'disabled' : formIsLoading}">
              <span v-if="!formIsLoading">Verzenden</span>
              <div v-else role="status" class="loading-container">
                <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="white" />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="#55ADFF" />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </button>
          </div>
        </form>

        <div v-else>
          <div class="container-block form-wrapper">
            <p class="text-blk contactus-head">
              Uw bericht is succesvol verzonden.
            </p>
            <p class="text-blk contactus-subhead">
              U zal zodra een bevestigingsmail ontvangen.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import emailjs from '@emailjs/browser';

const phoneRegex = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
const emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
const userTriedToSend = ref(false);
const formHasBeenSent = ref(false);
const formIsLoading = ref(false);
// used in error handling
const formFieldsValidity = ref({
  from_firstname: null,
  from_lastname: null,
  from_email: null,
  from_phonenumber: null,
  message: null
});
const formData = ref({
  from_firstname: '',
  from_lastname: '',
  from_email: '',
  from_phonenumber: '',
  message: ''
})
// gets sent to emailjs to send mail to company
const form = ref(null);

function handleData() {
  userTriedToSend.value = true;
  // checks validity of all fields in form
  if (formData.value.from_firstname.replace(/\s+/g, '') === '') {
    formFieldsValidity.value.from_firstname = false;
  } else {
    formFieldsValidity.value.from_firstname = true;
  }

  if (formData.value.from_lastname.replace(/\s+/g, '') === '') {
    formFieldsValidity.value.from_lastname = false;
  } else {
    formFieldsValidity.value.from_lastname = true;
  }

  if (formData.value.message.replace(/\s+/g, '') === '') {
    formFieldsValidity.value.message = false;
  } else {
    formFieldsValidity.value.message = true;
  }

  if (!phoneRegex.test(formData.value.from_phonenumber)) {
    formFieldsValidity.value.from_phonenumber = false;
  } else {
    formFieldsValidity.value.from_phonenumber = true;
  }

  if (!emailRegex.test(formData.value.from_email)) {
    formFieldsValidity.value.from_email = false;
  } else {
    formFieldsValidity.value.from_email = true;
  }

  // returns if even a single field validity is false
  if (!formFieldsValidity.value.from_firstname || !formFieldsValidity.value.from_lastname || !formFieldsValidity.value.from_email ||
    !formFieldsValidity.value.from_phonenumber || !formFieldsValidity.value.message) {
    return
  } else {
    sendMails();
  }

}

function sendMails() {
  formIsLoading.value = true;
  emailjs.sendForm("service_9ayw4qj", "template_l7j4xxs", form.value, "G7GxTr-V031IEBt4x")
    .then((result) => {
      formIsLoading.value = false;
      formHasBeenSent.value = true;
    }, (error) => {
      console.log('FAILED...', error.text);
    });
}

</script>

<style scoped>
.submit-btn.disabled {
  background-color: var(--main-light-blue) !important;
  color: gray;
  display: flex;
  justify-content: center;
}

.loading-container {
  display: flex;
  align-items: center;
}

.error {
  color: red;
  text-align: start;
  margin-left: 0.5rem;
}

@media (max-width: 769px) {
  .error {
    margin-left: 0rem;
  }
}

.contact_us_2 .text-blk {
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
  line-height: 25px;
}

.contact_us_2 .responsive-cell-block {
  min-height: 75px;
}

.contact_us_2 input:focus {
  outline-color: initial;
  outline-style: none;
  outline-width: initial;
}

.contact_us_2 .container-block {
  min-height: 75px;
  width: 100%;
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  display: block;
}

.contact_us_2 .submit-btn:hover {
  background-image: initial;
  background-position-x: initial;
  background-position-y: initial;
  background-size: initial;
  background-repeat-x: initial;
  background-repeat-y: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: var(--main-blue);
}

.contact_us_2 .responsive-container-block {
  min-height: 75px;
  height: fit-content;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 0px;
  margin-right: auto;
  margin-bottom: 50px;
  margin-left: auto;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.contact_us_2 .responsive-container-block.big-container {
  padding-top: 10px;
  padding-right: 30px;
  padding-bottom: 10px;
  padding-left: 30px;
  position: relative;
  height: auto;
}

.contact_us_2 .responsive-container-block.container {
  position: static;
  min-height: 75px;
  flex-direction: column;
  z-index: 2;
  max-width: 800px;
  margin-top: 120px;
  margin-right: auto;
  margin-bottom: 50px;
  margin-left: auto;
}

.contact_us_2 .container-block.form-wrapper {
  background-color: white;
  max-width: 799px;
  text-align: center;
  padding-top: 50px;
  padding-right: 40px;
  padding-bottom: 50px;
  padding-left: 40px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 20px 7px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  margin-top: 0px;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: auto;
}

.contact_us_2 .text-blk.contactus-head {
  font-size: 36px;
  line-height: 50px;
  font-weight: 900;
}

.contact_us_2 .text-blk.contactus-subhead {
  color: #9c9c9c;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 50px;
  margin-left: 0px;
}

.contact_us_2 .responsive-cell-block.wk-desk-6.wk-ipadp-6.wk-tab-12.wk-mobile-12 {
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 26px;
  margin-left: 0px;
  min-height: 50px;
}

.contact_us_2 .input {
  width: 96%;
  height: 50px;
  padding-top: 1px;
  padding-right: 15px;
  padding-bottom: 1px;
  padding-left: 15px;
  border-top-width: 2px;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-left-width: 2px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: #eeeeee;
  border-right-color: #eeeeee;
  border-bottom-color: #eeeeee;
  border-left-color: #eeeeee;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  font-size: 16px;
  color: black;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.contact_us_2 .textinput {
  width: 98%;
  min-height: 150px;
  padding-top: 20px;
  padding-right: 15px;
  padding-bottom: 20px;
  padding-left: 15px;
  border-top-width: 2px;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-left-width: 2px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: #eeeeee;
  border-right-color: #eeeeee;
  border-bottom-color: #eeeeee;
  border-left-color: #eeeeee;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.contact_us_2 .submit-btn {
  width: 98%;
  background-color: var(--main-blue);
  height: 60px;
  font-size: 20px;
  font-weight: 700;
  color: white;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  border-top-style: outset;
  border-right-style: outset;
  border-bottom-style: outset;
  border-left-style: outset;
  border-top-color: #767676;
  border-right-color: #767676;
  border-bottom-color: #767676;
  border-left-color: #767676;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  cursor: pointer;
}

.contact_us_2 .form-box {
  margin-top: 0px;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: auto;
}

.contact_us_2 .social-media-links {
  width: 250px;
  display: flex;
  justify-content: space-evenly;
  margin-top: 50px;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: auto;
}

.contact_us_2 .link-img {
  width: 30px;
  height: 30px;
}

.contact_us_2 .text-blk.input-title {
  text-align: left;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 10px;
  font-size: 14px;
  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 5px;
  margin-left: 0px;
  color: #9c9c9c;
}

.contact_us_2 ::placeholder {
  color: #dadada;
}

.contact_us_2 .blueBG {
  position: absolute;
  width: 100%;
  left: 0px;
  top: 0px;
  height: 300px;
  background-color: var(--main-blue);
}

@media (max-width: 768px) {
  .contact_us_2 .submit-btn {
    width: 100%;
  }

  .contact_us_2 .input {
    width: 100%;
  }

  .contact_us_2 .textinput {
    width: 100%;
  }

  .contact_us_2 .container-block.form-wrapper {
    margin-top: 80px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
  }

  .contact_us_2 .text-blk.input-title {
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
  }

  .contact_us_2 .responsive-container-block.container {
    margin-top: 80px;
    margin-right: 0px;
    margin-bottom: 50px;
    margin-left: 0px;
  }

  .contact_us_2 .container-block.form-wrapper {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
  }

  .contact_us_2 .text-blk.contactus-head {
    font-size: 30px;
    line-height: 40px;
  }
}

@media (max-width: 500px) {
  .contact_us_2 .container-block.form-wrapper {
    padding-top: 50px;
    padding-right: 15px;
    padding-bottom: 50px;
    padding-left: 15px;
  }

  .contact_us_2 .container-block.form-wrapper {
    margin-top: 60px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
  }

  .contact_us_2 .responsive-cell-block.wk-ipadp-6.wk-tab-12.wk-mobile-12.wk-desk-6 {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 15px;
    margin-left: 0px;
  }

  .contact_us_2 .responsive-container-block {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 35px;
    margin-left: 0px;
  }

  .contact_us_2 .text-blk.input-title {
    font-size: 12px;
  }

  .contact_us_2 .responsive-container-block.container {
    margin-top: 50px;
    margin-right: 0px;
    margin-bottom: 50px;
    margin-left: 0px;
  }

  .contact_us_2 .container-block.form-wrapper {
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
  }

  .contact_us_2 .responsive-container-block.big-container {
    padding-top: 10px;
    padding-right: 20px;
    padding-bottom: 10px;
    padding-left: 20px;
  }

  .contact_us_2 .text-blk.contactus-head {
    font-size: 26px;
    line-height: 34px;
  }

  .contact_us_2 .input {
    height: 45px;
  }
}

@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;600;700;800&amp;display=swap');

*,
*:before,
*:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

body {
  margin: 0;
}

.wk-desk-1 {
  width: 8.333333%;
}

.wk-desk-2 {
  width: 16.666667%;
}

.wk-desk-3 {
  width: 25%;
}

.wk-desk-4 {
  width: 33.333333%;
}

.wk-desk-5 {
  width: 41.666667%;
}

.wk-desk-6 {
  width: 50%;
}

.wk-desk-7 {
  width: 58.333333%;
}

.wk-desk-8 {
  width: 66.666667%;
}

.wk-desk-9 {
  width: 75%;
}

.wk-desk-10 {
  width: 83.333333%;
}

.wk-desk-11 {
  width: 91.666667%;
}

.wk-desk-12 {
  width: 100%;
}

@media (max-width: 1024px) {
  .wk-ipadp-1 {
    width: 8.333333%;
  }

  .wk-ipadp-2 {
    width: 16.666667%;
  }

  .wk-ipadp-3 {
    width: 25%;
  }

  .wk-ipadp-4 {
    width: 33.333333%;
  }

  .wk-ipadp-5 {
    width: 41.666667%;
  }

  .wk-ipadp-6 {
    width: 50%;
  }

  .wk-ipadp-7 {
    width: 58.333333%;
  }

  .wk-ipadp-8 {
    width: 66.666667%;
  }

  .wk-ipadp-9 {
    width: 75%;
  }

  .wk-ipadp-10 {
    width: 83.333333%;
  }

  .wk-ipadp-11 {
    width: 91.666667%;
  }

  .wk-ipadp-12 {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .wk-tab-1 {
    width: 8.333333%;
  }

  .wk-tab-2 {
    width: 16.666667%;
  }

  .wk-tab-3 {
    width: 25%;
  }

  .wk-tab-4 {
    width: 33.333333%;
  }

  .wk-tab-5 {
    width: 41.666667%;
  }

  .wk-tab-6 {
    width: 50%;
  }

  .wk-tab-7 {
    width: 58.333333%;
  }

  .wk-tab-8 {
    width: 66.666667%;
  }

  .wk-tab-9 {
    width: 75%;
  }

  .wk-tab-10 {
    width: 83.333333%;
  }

  .wk-tab-11 {
    width: 91.666667%;
  }

  .wk-tab-12 {
    width: 100%;
  }
}

@media (max-width: 500px) {
  .wk-mobile-1 {
    width: 8.333333%;
  }

  .wk-mobile-2 {
    width: 16.666667%;
  }

  .wk-mobile-3 {
    width: 25%;
  }

  .wk-mobile-4 {
    width: 33.333333%;
  }

  .wk-mobile-5 {
    width: 41.666667%;
  }

  .wk-mobile-6 {
    width: 50%;
  }

  .wk-mobile-7 {
    width: 58.333333%;
  }

  .wk-mobile-8 {
    width: 66.666667%;
  }

  .wk-mobile-9 {
    width: 75%;
  }

  .wk-mobile-10 {
    width: 83.333333%;
  }

  .wk-mobile-11 {
    width: 91.666667%;
  }

  .wk-mobile-12 {
    width: 100%;
  }
}

</style>